import styled, { css } from "styled-components";
import { BaseTheme } from "../Themes/BaseTheme";
import { FontSizeEnum, FontTypeEnum } from "./FontTextEnums";
import { ITheme } from "../Themes/ThemeTypes";
import { themeColor, themeFont } from "../Themes/ThemeFunctions";
import { ThemeColorEnum } from "../Themes/ThemeEnums";
import React from "react";

interface SpanProps {
  /**
   * Type of font
   */
  $fontType: FontTypeEnum;

  /**
   * Size of font
   */
  $fontSize: FontSizeEnum;

  /**
   * Color of text
   */
  $color?: ThemeColorEnum;
}

const Span = styled.span<{ $font: SpanProps; theme: ITheme }>`
  font-family: ${BaseTheme.typography.font};
  font-size: ${(props) => themeFont(props.$font.$fontType, props.$font.$fontSize).font_size}px;
  line-height: ${(props) => themeFont(props.$font.$fontType, props.$font.$fontSize).line_height}px;
  letter-spacing: ${(props) =>
    themeFont(props.$font.$fontType, props.$font.$fontSize).letter_spacing}px;
  font-weight: ${(props) => themeFont(props.$font.$fontType, props.$font.$fontSize).font_weight};

  ${(props) => {
    const color = themeColor(props.$font.$color, props.theme);
    if (color) {
      return css`
        color: ${color};
      `;
    }
  }};
`;

interface TextProps extends SpanProps {
  text: string;
}

const FontText: React.FC<TextProps> = ({ text, ...props }) => {
  return <Span $font={props}>{text}</Span>;
};

export default FontText;
